import { OVERDUE_STATUSES, SCRATCHPAY_ACCOUNT_URL, WELLNESS_PLAN_STATUSES } from "../../config/params";
/* eslint-disable max-len */
import React, { FC } from "react";
import { hasEndDateElapsed, isDateWithinFiveDays, isWithinPast30Days } from "../../utils/unix-timestamp";

import { IWellnessPlanByUser } from "../../services/wellness-plans-by-user/wellness-plan-by-user.interface";
import { OutstandingPaymentCard } from "..";

interface IOutstandingPaymentCardList{
    outstandingPaymentData: IWellnessPlanByUser[];
}

const OutstandingPaymentCardList: FC<IOutstandingPaymentCardList> = ({ outstandingPaymentData }) => {
  const getPetOverdueStatus = ({
    planStatus,
    isScratchpay,
    isOverdue,
  }: {
    planStatus: string;
    isScratchpay?: boolean;
    isOverdue?: boolean;
  }) => {
    const normalizedStatus = planStatus.toLowerCase();
    // Ensure locked plans take precedence over overdue.
    if (normalizedStatus === WELLNESS_PLAN_STATUSES.LOCKED) {
      return OVERDUE_STATUSES.PAUSED;
    }
    if (isScratchpay && isOverdue) {
      return OVERDUE_STATUSES.OVERDUE;
    }

    switch (normalizedStatus) {
    case WELLNESS_PLAN_STATUSES.PAUSED:
      return OVERDUE_STATUSES.PAUSED;
    case WELLNESS_PLAN_STATUSES.CANCELLED:
      return OVERDUE_STATUSES.CANCELLED;
    default:
      return null;
    }
  };

  return (
    <div className="flex flex-col gap-1.5">
      {outstandingPaymentData.map((outstandingPayment, index)=>{
        const effectivePlanStatus = outstandingPayment.wellnessPlanPaymentStatus;

        const paymentUrl =
          outstandingPayment.isScratchpay ?
            SCRATCHPAY_ACCOUNT_URL :
            (outstandingPayment.pendingSquareInvoices && outstandingPayment.pendingSquareInvoices.length > 0 ?
              outstandingPayment.pendingSquareInvoices[0].publicUrl :
              "");

        return <OutstandingPaymentCard
          key={index}
          planOverdueStatus={getPetOverdueStatus({
            planStatus: effectivePlanStatus,
            isScratchpay: outstandingPayment.isScratchpay,
            isOverdue: outstandingPayment.isOverdue,
          })}
          petId={outstandingPayment.pet.id}
          pendingInvoices={outstandingPayment.pendingSquareInvoices}
          paymentStatus={effectivePlanStatus}
          petName={outstandingPayment.pet.name}
          planEndDate={outstandingPayment.wellnessPlanDetails?.endDate}
          petImage={outstandingPayment.pet.image ? outstandingPayment.pet.image : ""}
          paymentUrl={paymentUrl}
          isScratchpay={outstandingPayment.isScratchpay}
          isRenewUnsuccessful={hasEndDateElapsed(outstandingPayment.wellnessPlanDetails?.endDate || "")}
          isCancelledRenewUnsuccessful={isWithinPast30Days(outstandingPayment.wellnessPlanDetails?.startDate || "") && outstandingPayment.wellnessPlanDetails?.renewalStatus}
          isPlanEndingInFiveDays={isDateWithinFiveDays(outstandingPayment.wellnessPlanDetails?.endDate || "")}
        />;
      })}
    </div>
  );
};

export default OutstandingPaymentCardList;
